type tileMap = {
  [key: string]: string;
};

type attendeeMap = {
  [key: string]: number;
};

export type State = {
  tiles: number[];
  tileIdToAttendeeId: tileMap;
  attendeeIdToTileId: attendeeMap;
};

export enum VideoTileActionType {
  UPDATE,
  REMOVE,
  RESET,
}

type UpdateAction = {
  type: VideoTileActionType.UPDATE;
  payload: {
    tileId: number;
    attendeeId: string;
  };
};

type RemoveAction = {
  type: VideoTileActionType.REMOVE;
  payload: {
    tileId: number;
    attendeeId?: string;
  };
};

type ResetAction = {
  type: VideoTileActionType.RESET;
  payload?: unknown;
};

export type Action = UpdateAction | RemoveAction | ResetAction;

export const initialState: State = {
  tiles: [],
  tileIdToAttendeeId: {},
  attendeeIdToTileId: {},
};

export function reducer(state: State, { type, payload }: Action): State {
  const { tiles, tileIdToAttendeeId, attendeeIdToTileId } = state;

  switch (type) {
    case VideoTileActionType.UPDATE: {
      const { tileId: newTileId, attendeeId: newAttendeeId = '' } = payload;

      const newTiles = [...tiles];
      const newTileIdToAttendeeId = { ...tileIdToAttendeeId };
      const newAttendeeIdToTileId = { ...attendeeIdToTileId };

      for (const [tileId, attendeeId] of Object.entries(tileIdToAttendeeId)) {
        if (attendeeId === newAttendeeId) {
          newTiles.splice(newTiles.indexOf(parseInt(tileId)), 1);
          delete newTileIdToAttendeeId[tileId];
          delete newAttendeeIdToTileId[attendeeId];
        }
      }

      return {
        tiles: [...newTiles, newTileId],
        tileIdToAttendeeId: {
          ...newTileIdToAttendeeId,
          [newTileId]: newAttendeeId,
        },
        attendeeIdToTileId: {
          ...newAttendeeIdToTileId,
          [newAttendeeId]: newTileId,
        },
      };
    }
    case VideoTileActionType.REMOVE: {
      // dispatch 하는 곳이 없는 액션이라 상태를 바꾸지 않는다.
      return state;
    }
    case VideoTileActionType.RESET: {
      return initialState;
    }
    default:
      throw new Error('Incorrect type in VideoProvider');
  }
}
